import { Injectable } from "@angular/core";
import { CommonState } from "@obg/ngx.common";

@Injectable({
	providedIn: "root",
})
export class OpenIdConnectSelector {
	getToken() {
		return (state: CommonState): string | undefined => state.openIdConnect?.token;
	}

	getError() {
		return (state: CommonState): string | undefined => state.openIdConnect?.error;
	}
}
